import { Box, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AssignmentTable } from '../../../../components/shared/tables/AssignmentTable';
import { RangeDto } from '../../../../app/services/api/range';

interface MenuRangesTabProps {
  ranges: RangeDto[];
  isLoading: boolean;
  assignedRangeIds: ReadonlySet<number>;
  originalAssignedRangeIds: ReadonlySet<number>;
  onToggle: (rangeId: number) => void;
  onRangeClick: (rangeId: number) => void;
  readOnly?: boolean;
}

const MenuRangesTab = ({ ranges, isLoading, assignedRangeIds, originalAssignedRangeIds, onToggle, onRangeClick, readOnly = false }: MenuRangesTabProps) => {
  const { t } = useTranslation('range');

  return (
    <Box>
      <AssignmentTable<RangeDto>
        title={t('ranges')}
        items={ranges}
        getRowId={(row) => row.id}
        getSearchableText={(row) => row.name}
        assignedIds={assignedRangeIds}
        originalAssignedIds={originalAssignedRangeIds}
        onToggle={onToggle}
        readOnly={readOnly}
        onRowClick={(row) => onRangeClick(row.id)}
        loading={isLoading}
        pageSize={10}
        searchPlaceholder={t('searchPlaceholder')}
        emptyMessage={t('noRangesFound')}
        columns={[
          {
            id: 'name',
            label: t('name'),
            render: (row) => (
              <Link
                component="button"
                type="button"
                underline="hover"
                onClick={(event) => {
                  event.stopPropagation();
                  onRangeClick(row.id);
                }}
              >
                {row.name}
              </Link>
            ),
          },
          { id: 'description', label: t('description'), render: (row) => row.description || t('notSet') },
        ]}
      />
    </Box>
  );
};

export default MenuRangesTab;
